export const truncateAddress = (address) => {
    if (!address)
        return '';
    if (address.length < 12)
        return address;
    return `${address.slice(0, 4)}...${address.slice(-4)}`;
};
